import api from './api/api';

class InitService {
  initMe() {
    return api.get('/auth/me/')
  }
}

export default new InitService();
